import { Text } from "@/components/ui/text";
import { HStack } from "@/components/ui/hstack";
import { Button } from "@/components/ui/button";
import React, {useState} from 'react';
import i18n from "i18n-js";
import { IconM } from '@/components/media/IconsV2'

export default function SimulatorButton({valid, onOpenSimulator}){
    return (
        <>
            <Button isDisabled={!valid} onPress={() => {onOpenSimulator()}} className="h-[34px] bg-ina-green">
                <HStack space='xs' className="items-center">
                    <IconM className='text-secondary-50' name='smartphone'/>
                    <Text className="text-secondary-50">{i18n.t('studio.flow.openSimulator')}</Text>
                </HStack>
            </Button>
        </>
    );
}